var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Container',{staticClass:"container-sm-none"},[_c('Card',{staticClass:"card-shadow mt-15 mt-md-0"},[_c('div',{staticClass:"width-lg"},[_c('div',{staticClass:"pl-10 pl-md-0 pr-10 pr-md-0"},[_c('IconSadPerson'),_c('p',{staticClass:"heading-2 heading-md-1 weight-medium mt-20"},[_vm._v(" Sorry, the service is currently unavailable. ")])],1)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }